var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    [
      _c(
        "v-banner",
        { staticClass: "opportunity-user-input", attrs: { sticky: "" } },
        [
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_date"
              ),
              "detail-value": [_vm.parseDate(_vm.form["applyInfoApplyDate"])]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_seihin"
              ),
              "detail-value": [
                _vm.$t("view.sales_force.reflect.label.contract.oral_care")
              ]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_period"
              ),
              "detail-value": [_vm.getPlanName()]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.contract_form.update.label.apply_info.start_date"
              ),
              "detail-value": [
                _vm.parseDate(_vm.form["applyInfoOralCareSstartDate"])
              ]
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-expansion-panels",
        {
          attrs: { accordion: "", flat: "", multiple: "" },
          model: {
            value: _vm.salesForceInfo.useOralCareFreePeriod,
            callback: function($$v) {
              _vm.$set(_vm.salesForceInfo, "useOralCareFreePeriod", $$v)
            },
            expression: "salesForceInfo.useOralCareFreePeriod"
          }
        },
        [
          _c(
            "v-expansion-panel",
            { attrs: { readonly: "" } },
            [
              _c(
                "v-expansion-panel-header",
                { staticClass: "pa-0 mt-0" },
                [
                  _c("v-checkbox", {
                    attrs: { value: "true", "hide-details": "" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function() {
                          return [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "apply-service-label text-black font-weight-bold subtitle-1"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "view.sales_force.reflect.button_caption.add_opportunity"
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.useOralCareFreePeriod,
                      callback: function($$v) {
                        _vm.useOralCareFreePeriod = $$v
                      },
                      expression: "useOralCareFreePeriod"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-expansion-panel-content",
                [
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.free_opportunity_id"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "8", md: "4" }
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "mt-0 pt-0 pb-0",
                            attrs: {
                              "persistent-hint": "",
                              hint: _vm.$t(
                                "view.sales_force.reflect.hint.opportunity.opportunity_id"
                              ),
                              placeholder: _vm.$t(
                                "view.sales_force.reflect.placeholder.opportunity.opportunity_id"
                              ),
                              autocomplete: "off"
                            },
                            model: {
                              value:
                                _vm.salesForceInfo.freeOpportunityOralCareId,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "freeOpportunityOralCareId",
                                  $$v
                                )
                              },
                              expression:
                                "salesForceInfo.freeOpportunityOralCareId"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
                          attrs: { cols: "12", sm: "4", md: "4" }
                        },
                        [
                          _c("move-sales-force-button", {
                            attrs: {
                              "sales-force-id":
                                _vm.salesForceInfo.freeOpportunityOralCareId,
                              "sales-force-type": "Opportunity"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.free_opportunity_item_id"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "8", md: "4" }
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "mt-0 pt-0 pb-0",
                            attrs: {
                              "persistent-hint": "",
                              hint: _vm.$t(
                                "view.sales_force.reflect.hint.opportunity.opportunity_line_item_id"
                              ),
                              placeholder: _vm.$t(
                                "view.sales_force.reflect.placeholder.opportunity.opportunity_line_item_id"
                              ),
                              autocomplete: "off"
                            },
                            model: {
                              value:
                                _vm.salesForceInfo
                                  .freeOpportunityOralCareItemId,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "freeOpportunityOralCareItemId",
                                  $$v
                                )
                              },
                              expression:
                                "salesForceInfo.freeOpportunityOralCareItemId"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
                          attrs: { cols: "12", sm: "4", md: "4" }
                        },
                        [
                          _c("move-sales-force-button", {
                            attrs: {
                              "sales-force-id":
                                _vm.salesForceInfo
                                  .freeOpportunityOralCareItemId,
                              "sales-force-type": "OpportunityLineItem"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.free_opportunity_name"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "8", md: "4" }
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "mt-0 pt-0 pb-0",
                            attrs: {
                              "persistent-hint": "",
                              placeholder: _vm.$t(
                                "view.sales_force.reflect.placeholder.opportunity.opportunity_name"
                              ),
                              autocomplete: "off"
                            },
                            model: {
                              value:
                                _vm.salesForceInfo.freeOpportunityOralCareName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "freeOpportunityOralCareName",
                                  $$v
                                )
                              },
                              expression:
                                "salesForceInfo.freeOpportunityOralCareName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.price_book.price_book_select_free"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "12", md: "5" }
                        },
                        [
                          _c("price-book-select", {
                            attrs: { "price-book-items": _vm.priceBookData },
                            on: {
                              "price-book-change": _vm.freePriceBookChange
                            },
                            model: {
                              value:
                                _vm.salesForceInfo.oralCareFreePriceBook2Id,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "oralCareFreePriceBook2Id",
                                  $$v
                                )
                              },
                              expression:
                                "salesForceInfo.oralCareFreePriceBook2Id"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.cancel_flg"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "12", md: "5" }
                        },
                        [
                          _c("v-checkbox", {
                            staticClass: "mt-0",
                            attrs: {
                              "persistent-hint": "",
                              disabled: _vm.isCancelFlgDisable(),
                              "input-value":
                                _vm.salesForceInfo.oralCareCancelFlag,
                              value: _vm.$t(
                                "view.sales_force.reflect.data_labels.contract.cancel_flg.value"
                              ),
                              label: _vm.$t(
                                "view.sales_force.reflect.data_labels.contract.cancel_flg.label"
                              )
                            },
                            model: {
                              value: _vm.salesForceInfo.oralCareCancelFlag,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "oralCareCancelFlag",
                                  $$v
                                )
                              },
                              expression: "salesForceInfo.oralCareCancelFlag"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.product_free"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "12", md: "5" }
                        },
                        [
                          _c("product-select", {
                            attrs: {
                              "price-book-id":
                                _vm.salesForceInfo.oralCarePriceBook2Id,
                              product: _vm.$t(
                                "view.sales_force.reflect.label.opportunity.oral_care"
                              ),
                              period: _vm.getSalesForcePeriod()
                            },
                            on: { "product-change": _vm.freeProductChange },
                            model: {
                              value: _vm.salesForceInfo.oralCareFreeProductId,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "oralCareFreeProductId",
                                  $$v
                                )
                              },
                              expression: "salesForceInfo.oralCareFreeProductId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.free_period"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "12", md: "5" }
                        },
                        [
                          _c("free-period", {
                            on: { input: _vm.periodChange },
                            model: {
                              value: _vm.salesForceInfo.oralCareFreePeriod,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "oralCareFreePeriod",
                                  $$v
                                )
                              },
                              expression: "salesForceInfo.oralCareFreePeriod"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.free_start_date"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "12", md: "5" }
                        },
                        [
                          _c("date-picker-wrapper", {
                            attrs: {
                              classes: "mt-0 pt-0 pb-0",
                              disabled: true,
                              type: "date"
                            },
                            model: {
                              value:
                                _vm.salesForceInfo
                                  .freeOralCareContractStartDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "freeOralCareContractStartDate",
                                  $$v
                                )
                              },
                              expression:
                                "salesForceInfo.freeOralCareContractStartDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider", { staticClass: "mt-2" }),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.opportunity_id"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "8", md: "4" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.contract_id"
                  ),
                  placeholder: _vm.$t(
                    "view.sales_force.reflect.placeholder.contract.contract_id"
                  ),
                  autocomplete: "off"
                },
                model: {
                  value: _vm.salesForceInfo.opportunityOralCareId,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "opportunityOralCareId", $$v)
                  },
                  expression: "salesForceInfo.opportunityOralCareId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
              attrs: { cols: "12", sm: "4", md: "4" }
            },
            [
              _c("move-sales-force-button", {
                attrs: {
                  "sales-force-id": _vm.salesForceInfo.opportunityOralCareId,
                  "sales-force-type": "Opportunity"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.opportunity_line_item_id"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "8", md: "4" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.opportunity.opportunity_line_item_id"
                  ),
                  placeholder: _vm.$t(
                    "view.sales_force.reflect.placeholder.opportunity.opportunity_line_item_id"
                  ),
                  autocomplete: "off"
                },
                model: {
                  value: _vm.salesForceInfo.opportunityOralCareItemId,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.salesForceInfo,
                      "opportunityOralCareItemId",
                      $$v
                    )
                  },
                  expression: "salesForceInfo.opportunityOralCareItemId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
              attrs: { cols: "12", sm: "4", md: "4" }
            },
            [
              _c("move-sales-force-button", {
                attrs: {
                  "sales-force-id":
                    _vm.salesForceInfo.opportunityOralCareItemId,
                  "sales-force-type": "OpportunityLineItem"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.opportunity_name"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "8", md: "4" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.opportunity.opportunity_name"
                  ),
                  placeholder: _vm.$t(
                    "view.sales_force.reflect.placeholder.opportunity.opportunity_name"
                  ),
                  autocomplete: "off"
                },
                model: {
                  value: _vm.salesForceInfo.opportunityOralCareName,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "opportunityOralCareName", $$v)
                  },
                  expression: "salesForceInfo.opportunityOralCareName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.price_book.price_book_select"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("price-book-select", {
                attrs: { "price-book-items": _vm.priceBookData },
                model: {
                  value: _vm.salesForceInfo.oralCarePriceBook2Id,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "oralCarePriceBook2Id", $$v)
                  },
                  expression: "salesForceInfo.oralCarePriceBook2Id"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.product"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("product-select", {
                attrs: {
                  "price-book-id": _vm.salesForceInfo.oralCarePriceBook2Id,
                  product: _vm.$t(
                    "view.sales_force.reflect.label.opportunity.oral_care"
                  ),
                  period: _vm.getSalesForcePeriod()
                },
                on: {
                  "price-change": _vm.oralCarePriceChange,
                  "product-change": _vm.productChange,
                  "entry-change": _vm.entryChange
                },
                model: {
                  value: _vm.salesForceInfo.oralCareProductId,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "oralCareProductId", $$v)
                  },
                  expression: "salesForceInfo.oralCareProductId"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.unit_price"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "10", sm: "10", md: "5" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  disabled: "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.price_input_base"
                  ),
                  autocomplete: "off",
                  type: "number",
                  suffix: _vm.$t("view.sales_force.reflect.label.contract.yen")
                },
                model: {
                  value: _vm.oralCarePrice,
                  callback: function($$v) {
                    _vm.oralCarePrice = $$v
                  },
                  expression: "oralCarePrice"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.price"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  "error-messages": _vm.getPriceErrorMsg(),
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.price_kobetu"
                  ),
                  autocomplete: "off",
                  type: "number",
                  suffix: _vm.$t("view.sales_force.reflect.label.contract.yen")
                },
                model: {
                  value: _vm.salesForceInfo.oralCcarePrice,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "oralCcarePrice", $$v)
                  },
                  expression: "salesForceInfo.oralCcarePrice"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.apply_start_date"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("date-picker-wrapper", {
                attrs: {
                  classes: "mt-0 pt-0 pb-0",
                  disabled: true,
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.apply_start_date"
                  ),
                  type: "date"
                },
                model: {
                  value: _vm.salesForceInfo.oralCareContractStartDate,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.salesForceInfo,
                      "oralCareContractStartDate",
                      $$v
                    )
                  },
                  expression: "salesForceInfo.oralCareContractStartDate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.request_start_date"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("date-picker-wrapper", {
                attrs: {
                  classes: "mt-0 pt-0 pb-0",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.request_start_date"
                  ),
                  type: "date"
                },
                model: {
                  value: _vm.salesForceInfo.oralCareRequestStartDate,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.salesForceInfo,
                      "oralCareRequestStartDate",
                      $$v
                    )
                  },
                  expression: "salesForceInfo.oralCareRequestStartDate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.contract_edate"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("date-picker-wrapper", {
                attrs: {
                  classes: "mt-0 pt-0 pb-0",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.contract_edate"
                  ),
                  type: "date"
                },
                model: {
                  value: _vm.salesForceInfo.oralCareContractEdate,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "oralCareContractEdate", $$v)
                  },
                  expression: "salesForceInfo.oralCareContractEdate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3  align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.bunkatsu"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "8" }
            },
            [
              _c("v-checkbox", {
                staticClass: "mt-0",
                attrs: {
                  "persistent-hint": "",
                  "input-value": _vm.salesForceInfo.oralCareBunkatuFlg,
                  value: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.bunkatsu.value"
                  ),
                  label: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.bunkatsu.label"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.oralCareBunkatuFlg,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "oralCareBunkatuFlg", $$v)
                  },
                  expression: "salesForceInfo.oralCareBunkatuFlg"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.it_flg"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "8" }
            },
            [
              _c("v-checkbox", {
                staticClass: "mt-0",
                attrs: {
                  "persistent-hint": "",
                  "input-value": _vm.salesForceInfo.oralCareItFlg,
                  value: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.it_flg.value"
                  ),
                  label: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.it_flg.label"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.oralCareItFlg,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "oralCareItFlg", $$v)
                  },
                  expression: "salesForceInfo.oralCareItFlg"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 fixed-label-area align-center",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold fixed-label ml-4" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.tokubetu_detail"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "8" }
            },
            [
              _c("v-textarea", {
                staticClass: "mt-0",
                attrs: {
                  outlined: "",
                  rows: "2",
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.tokubetu_detail"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.oralCareTokubetuDetail,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "oralCareTokubetuDetail", $$v)
                  },
                  expression: "salesForceInfo.oralCareTokubetuDetail"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("sales-force-button-area", {
        attrs: { "disable-csv-output": true },
        on: { reflect: _vm.submit, "re-correct": _vm.reCorrect }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showConfirmDialog,
          "max-width": "800",
          "default-msg": _vm.confirmMessage
        },
        on: {
          "ok-click": function($event) {
            return _vm.reflect()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showAlertDialog,
          "max-width": "800",
          "is-confirm": false,
          "default-msg": _vm.alertMessage
        },
        on: {
          "ok-click": function($event) {
            return _vm.dialogClose()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-238e414a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-238e414a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sales_force/OpportunityOralCare.vue
// module id = C58f
// module chunks = 1